import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { spinnerStyles } from './styles';
let LitSpinner = class LitSpinner extends LitElement {
    constructor() {
        super(...arguments);
        this.big = false;
        this.small = false;
        this.fullContent = false;
        this.fullscreen = false;
    }
    render() {
        return html `
            <div class = "pulsor">
                <div class="bounce bounce1"></div>
                <div class="bounce bounce2"></div>
            </div>
        `;
    }
};
LitSpinner.styles = spinnerStyles;
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitSpinner.prototype, "big", void 0);
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitSpinner.prototype, "small", void 0);
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitSpinner.prototype, "fullContent", void 0);
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitSpinner.prototype, "fullscreen", void 0);
LitSpinner = __decorate([
    customElement('lit-spinner')
], LitSpinner);
export { LitSpinner };
